// @ts-nocheck
import React, { useEffect, useState } from "react";
import * as Styled from "./Layout3.styled";
import { LivestreamLayoutCommonProps } from "../../../types";
import { ArrowLeft, ArrowRight } from 'react-bootstrap-icons';
import { scrollOnce, startContinuousScroll, stopContinuousScroll } from "../../../libs/utils";
import { SeeCard } from "../../media-card/see-card";
import { BigCard } from "../../event-card/big-card";
import { SmallCard } from "../../event-card/small-card";
import LayoutModal from "../../event-card/FullScreenModal";
import { LayoutHeader } from "../../layouts/LayoutHeader";
import { filterEventsByType } from "../../../libs/utils/eventFilter";
import { EmptyLiveStreams } from "../../empty-state";

export const Layout3: React.FC<LivestreamLayoutCommonProps> = ({
    events,
    sessionToken,
    isSignedIn,
    activePlans,
    hasFullAccess,
    freeTrialPlanIds,
    onWatchClick
}) => {
    const [selectedOption, setSelectedOption] = React.useState<any>('All');
    const rightScrollRef = React.useRef<HTMLDivElement>(null);
    const scrollIntervalRef = React.useRef<NodeJS.Timeout | null>(null);
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const [mainEvent, setMainEvent] = useState<ILiveStream | undefined>(undefined);
    
    const [selectedCardId, setSelectedCardId] = useState<string | null>(null);

    const handleSeeAllClick = () => {
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    useEffect(() => {
        console.log("Events changed: ", events);
        if (events.length && !mainEvent) {
            const firstMedia = events[0];
            console.log("First media: ", firstMedia);
            setMainEvent(firstMedia);
            setSelectedCardId(firstMedia.id);
        }
    }, [events, mainEvent]);

    const onCardClick = (item: any) => {
        setMainEvent(item);
        setSelectedCardId(item.id);
    };

    const filteredEvents = filterEventsByType(events, selectedOption);
    if (events.length === 0) {
        return <EmptyLiveStreams />;
    }



    return (
        <>
            <Styled.FullHeightWrapper>
                <LayoutHeader
                    title={'Live Streams'}
                    itemCount={filteredEvents?.length}
                    selectedOption={selectedOption}
                    setSelectedOption={setSelectedOption}
                    onSeeAll={handleSeeAllClick}
                    padding="20px 10px 0px 0px"
                    marginTop="0px"
                    showToggle={true}
                    isLivestream={true}
                />
                {filteredEvents.length === 0 ? (
                    <EmptyLiveStreams showHeader={false} isFiltered={true}/>
                ) : (
                    <Styled.Container>
                        <Styled.BigCard>
                            {mainEvent && (
                                <BigCard
                                    event={mainEvent}
                                    isSignedIn={isSignedIn}
                                    hasEligiblePlan={
                                        isSignedIn &&
                                        (!!mainEvent.planDetails.length
                                            ? !!activePlans.filter((memberPlan) =>
                                                mainEvent.planDetails.some((plan) => plan?.id === memberPlan.id)
                                            ).length || freeTrialPlanIds.includes(mainEvent.id) || hasFullAccess
                                            : true)
                                    }
                                    onWatchClick={onWatchClick}
                                />
                            )}
                        </Styled.BigCard>



                        <Styled.SidebarCard>
                            {/* Arrows */}
                            {true && (
                                <div>
                                    <Styled.ArrowLeft
                                        onClick={() => scrollOnce(rightScrollRef, "left")}
                                        onMouseDown={() =>
                                            startContinuousScroll(rightScrollRef, "left", scrollIntervalRef)
                                        }
                                        onMouseUp={() => stopContinuousScroll(scrollIntervalRef)}
                                        onMouseLeave={() => stopContinuousScroll(scrollIntervalRef)}
                                        title="Scroll Left"
                                    >
                                        <ArrowLeft size={30} />
                                    </Styled.ArrowLeft>

                                    <Styled.ArrowRight
                                        onClick={() => scrollOnce(rightScrollRef, "right")}
                                        onMouseDown={() =>
                                            startContinuousScroll(rightScrollRef, "right", scrollIntervalRef)
                                        }
                                        onMouseUp={() => stopContinuousScroll(scrollIntervalRef)}
                                        onMouseLeave={() => stopContinuousScroll(scrollIntervalRef)}
                                        title="Scroll Right"
                                    >
                                        <ArrowRight size={30} />
                                    </Styled.ArrowRight>
                                </div>
                            )}
                            <Styled.SidebarCardContent>
                                <Styled.ScrollableList ref={rightScrollRef} scrollable={true}>
                                    {filteredEvents.map((item, index) => (
                                        <Styled.SidebarCardWrapper key={item.id}>
                                            <SmallCard
                                                event={item}
                                                cardClick={() => onCardClick(item)}
                                                isSelected={item.id === selectedCardId}
                                                isSignedIn={isSignedIn}
                                                hasEligiblePlan={
                                                    isSignedIn &&
                                                    (!!item.planDetails.length
                                                        ? !!activePlans.filter((memberPlan) =>
                                                            item.planDetails.some((plan) => plan?.id === memberPlan.id)
                                                        ).length || freeTrialPlanIds.includes(item.id) || hasFullAccess
                                                        : true)
                                                }
                                                onWatchClick={onWatchClick}
                                                bodyWidth="280px"
                                            />
                                        </Styled.SidebarCardWrapper>
                                    )
                                    )}

                                    {/* SeeCard at end */}
                                    {events.length > 6 && (
                                        <Styled.SeeAllWrapper onClick={handleSeeAllClick}>
                                            <SeeCard />
                                        </Styled.SeeAllWrapper>
                                    )}
                                </Styled.ScrollableList>
                            </Styled.SidebarCardContent>
                        </Styled.SidebarCard>
                    </Styled.Container>
                )}
            </Styled.FullHeightWrapper>
            {/* Modal with Lazy Loaded Cards */}
            <LayoutModal
                show={isModalOpen}
                onHide={handleCloseModal}
                filteredLiveEvents={events}
                isSignedIn={isSignedIn}
                activePlans={activePlans}
                hasFullAccess={hasFullAccess}
                freeTrialPlanIds={freeTrialPlanIds}
                onWatchClick={onWatchClick}
            />
        </>
    );
};

